import { TextProps } from './../types';
import { css } from 'styled-components';
export const getTextAlign = (props: TextProps) => {
    const { fromStart, textAlign } = props;
    const value = fromStart ? "start" : textAlign ?? "center";
    return css`
        text-align: ${value}
    `
}